// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getApiErrorMessage(error: any): string {
  const data = error?.response?.data;

  // 1️⃣ Padrão: errors { campo: [mensagem] }
  if (data?.errors && typeof data.errors === 'object') {
    const firstKey = Object.keys(data.errors)[0];

    if (Array.isArray(data.errors[firstKey])) {
      return data.errors[firstKey][0];
    }

    if (typeof data.errors[firstKey] === 'string') {
      return data.errors[firstKey];
    }
  }

  // 2️⃣ Padrão: message
  if (typeof data?.message === 'string') {
    return data.message;
  }

  // 3️⃣ Padrão: title
  if (typeof data?.title === 'string') {
    return data.title;
  }

  // 4️⃣ Axios / erro genérico
  if (typeof error?.message === 'string') {
    return error.message;
  }

  // 5️⃣ Fallback final
  return 'Erro inesperado. Tente novamente.';
}

export default getApiErrorMessage;
